import { useQuery } from '@tanstack/react-query';
import { carReportsApi } from '../api/carReportsApi';

export const useReport = (id: string) => {
  return useQuery({
    queryKey: ['report', id],
    queryFn: () => carReportsApi.getReport(id),
  });
};

export const useRentingReports = (rentingId: string) => {
  return useQuery({
    queryKey: ['reports', rentingId],
    queryFn: () => carReportsApi.getReports(),
    select: (data) => data.data.filter((report) => report.renting.id === rentingId),
  });
};
